import type {Route} from "@tanstack/react-router";
import {IntellsysLoadingOverlay} from "~/components/routerHelpers/intellsysLoadingOverlay";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function NonEmbeddedPendingComponent({route}: {route: Route}) {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", route.id, "pendingComponent");
    }

    return <IntellsysLoadingOverlay message={`Loading ${route.id}`} />;
}
